import { render, staticRenderFns } from "./WizardRewardsStep.vue?vue&type=template&id=0dffcab8&scoped=true&"
import script from "./WizardRewardsStep.vue?vue&type=script&lang=js&"
export * from "./WizardRewardsStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardRewardsStep.vue?vue&type=style&index=0&id=0dffcab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dffcab8",
  null
  
)

export default component.exports